import { listApiTemplate } from "../list";
import { IVersionControl } from "../../../../interfaces/collection/ICollection";
export const prodListApiTemplate = {
  name: 'prodList',
  desc: '正式表列表',
  required: false,
  dbMethod: 'prodList',
  request: listApiTemplate.request,
  response: listApiTemplate.response,
  version: IVersionControl.Row,
  group: '列表接口'
};
//# sourceMappingURL=prodList.js.map
